import projectComponent from '../../Project';
import app from '../../../app';

async function onProjectRestored(event) {
  await projectComponent.onArchivedProject({
    ganttId: event.data.project.projectId,
    isArchived: 0,
  });

  app.trigger('onAfterCollaboration', {
    event: event.event,
    projects: [event.data.project.projectId],
  });
}

export default onProjectRestored;
